module.exports = __webpack_public_path__ + "img/change_permission.3b3aa35e.jpg";